import axios from 'axios';
var moment = require('moment');
//Get current user(me) from token in localStorage
export const ME_FROM_TOKEN = 'ME_FROM_TOKEN';
export const ME_FROM_TOKEN_SUCCESS = 'ME_FROM_TOKEN_SUCCESS';
export const ME_FROM_TOKEN_FAILURE = 'ME_FROM_TOKEN_FAILURE';
export const RESET_TOKEN = 'RESET_TOKEN';

//Sign Up User
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNUP_USER_FAILURE = 'SIGNUP_USER_FAILURE';
export const RESET_USER = 'RESET_USER';

//Sign Up Subscriber
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_SUBSCRIPTION_EMAIL = 'SET_SUBSCRIPTION_EMAIL';
export const STOP_SUBMIT_FORM = 'STOP_SUBMIT_FORM';
export const PROCESSED_SUBSCRIBER = 'PROCESSED_SUBSCRIBER';
export const LOAD_PRODUCT = 'LOAD_PRODUCT';
export const ACCEPT_CONTRACT = 'ACCEPT_CONTRACT';

export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_USER_FAILURE = 'SIGNIN_USER_FAILURE';

//Steps by providers
export const LOAD_CBU = 'LOAD_CBU';

export const SAVE_AFFIDAVIT = 'SAVE_AFFIDAVIT';

//Sms Validation
export const VERIFY_CODE = 'VERIFY_CODE';

//Address Form
export const SAVE_ADDRESS = 'SAVE_ADDRESS';

export const SAVE_JOB_INFO = 'SAVE_JOB_INFO';

export const SAVE_EMAIL = 'SAVE_EMAIL';

export const SAVE_PERSONAL_INFO = 'SAVE_PERSONAL_INFO';

export const SAVE_SERVICE_INFO = 'SAVE_SERVICE_INFO';

export const SAVE_INCOMES = 'SAVE_INCOMES';

export const SAVE_FILES = 'SAVE_FILES';

//validate email, if success, then load user and login
export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';
export const VALIDATE_EMAIL_FAILURE = 'VALIDATE_EMAIL_FAILURE';

//called when email is updated in profile to update main user's email state
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';

//log out user
export const LOGOUT_USER = 'LOGOUT_USER';

export const GET_NEXT_STEP = 'GET_NEXT_STEP';


const ROOT_URL = process.env.API_URL;

export function meFromTokenSuccess(currentUser) {
    return {
        type: ME_FROM_TOKEN_SUCCESS,
        payload: currentUser
    };
}

export function meFromTokenFailure(error) {
    return {
        type: ME_FROM_TOKEN_FAILURE,
        payload: error
    };
}

export function resetToken() {//used for logout
    return {
        type: RESET_TOKEN
    };
}

export function resetUser() {
    return {
        type: RESET_USER,
    };
}

export function submitForm() {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    return {
        type: SUBMIT_FORM,
        payload: sleep(1)
    };
}

export function setSubscriptionEmail(formValues, jwt_token) {
    var headers = {
        'Content-Type': 'application/json'
    }

    const request = axios.put(`${ROOT_URL}/subscribers/by_jwt/` + sessionStorage.getItem('jwtAuthToken'), formValues, headers);

    return {
        type: SET_SUBSCRIPTION_EMAIL,
        payload: request
    };
}

export function stopSubmitForm() {

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    return {
        type: STOP_SUBMIT_FORM,
        payload: sleep(1)
    };
}

export function processSubscriber(formValues) {
    var headers = {
        'Content-Type': 'application/json'
    }

    const request = axios.post(`${ROOT_URL}/subscribers/process`, formValues, headers);

    return {
        type: PROCESSED_SUBSCRIBER,
        payload: request
    };
}

export function loadProduct(product) {
    var config = {
        headers:
        {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/leads/product`, product, config);

    return {
        type: LOAD_PRODUCT,
        payload: request
    };
}

export function loadCbu(cbu) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/leads/cbu`, cbu, config);

    return {
        type: LOAD_CBU,
        payload: request
    };
}

export function verifyCode(sms_code) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'code': sms_code
    };

    const request = axios.post(`${ROOT_URL}/sms/verify_code`, data, config);

    return {
        type: VERIFY_CODE,
        payload: request
    };
}

export function acceptContract(values) {
    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    }
    const { contract_accepted } = values

    const request = axios.put(`${ROOT_URL}/leads/contracts/${values.endpoint}`, { contract_accepted }, config);

    return {
        type: ACCEPT_CONTRACT,
        payload: request
    };
}

export function saveAffidavit(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/leads/affidavit`, values, config);

    return {
        type: SAVE_AFFIDAVIT,
        payload: request
    };
}

export function signInUserSuccess(user) {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: user
  };
}

export function signInUserFailure(error) {
  return {
    type: SIGNIN_USER_FAILURE,
    payload: error
  };
}

export function logoutUser() {
  return {
    type: LOGOUT_USER
  };
}

export function updateUserEmail(email) {
  return {
    type: UPDATE_USER_EMAIL,
    payload: email
  };
}

export function validateEmail() {
  return {
    type: VALIDATE_EMAIL
  }
}

export function getNextStep() {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.get(`${ROOT_URL}/leads/steps/next`, config);
    return {
        type: GET_NEXT_STEP,
        payload: request
    };
}

export function saveAddress(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'address_street': values.address_street,
        'address_description': values.address_description,
        'income': values.income,
        'zip_code': values.zip_code,
        'form_locality': values.form_locality,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/address`, data, config);

    return {
        type: SAVE_ADDRESS,
        payload: request
    };
}

export function saveJobInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var now = moment(new Date());
    var initDate = now.subtract(values.init_date, 'months').subtract(1, 'days');

    var data = {
        'vehicle': values.vehicle,
        'job_type': values.job_type,
        'init_date': initDate.format("YYYY-MM-DD"),
        'remuneration_without_taxes': values.remuneration_without_taxes,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/job_info`, data, config);

    return {
        type: SAVE_JOB_INFO,
        payload: request
    };
}

export function saveEmail(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'email': values.email,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/email`, data, config);

    return {
        type: SAVE_EMAIL,
        payload: request
    };
}

export function savePersonalInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'marital_status': values.marital_status,
        'couple_has_employment': values.couple_has_employment,
        'partner_incomes': values.partner_incomes,
        'people_in_house': values.people_in_house,
        'house_condition': values.house_condition,
        'breadwinner': values.breadwinner,
        'rental_price': values.rental_price,
        'bathrooms': values.bathrooms,
        'bedrooms': values.bedrooms,
        'children': values.children,
        'independent_children': (values.children - values.dependent_children).toString(),
        'children_in_school': values.children_in_school,
        'children_institution_type': values.children_institution_type
    };

    const request = axios.put(`${ROOT_URL}/subscribers/personal_info`, data, config);

    return {
        type: SAVE_PERSONAL_INFO,
        payload: request
    };
}

export function saveServiceInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'vehicle': values.vehicle,
        'car_insurance': values.car_insurance,
        'life_insurance': values.life_insurance,
        'house_insurance': values.house_insurance,
        'services': values.services,
        'tv_service': values.tv_service,
        'internet_service': values.internet_service
    };

    const request = axios.put(`${ROOT_URL}/subscribers/service_info`, data, config);

    return {
        type: SAVE_SERVICE_INFO,
        payload: request
    };
}

export function saveIncomes(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    /*var data = {
        'leasing_type': values.leasing_type,
        'monotributo_category': values.monotributo_category,
        'monthly_costs': values.monthly_costs,
        'number_of_employees': values.number_of_employees,
        'self_employment_incomes': values.self_employment_incomes.map((income) => { return {...income, date: income.date.format("YYYY-MM-DD")}})
    };*/
    let data = {...values}

    var now = moment(new Date());
    var baseDate = now.subtract(1, 'month').startOf('month');

    if('self_employment_incomes' in values){
        data = {...values, self_employment_incomes: values.self_employment_incomes.map((income) => { return {...income, income_date: income.income_date.format("YYYY-MM-DD")}})}
    }

    if('check_stubs' in values){
        data = {...values, check_stubs: values.check_stubs.map((check_stub) => { return {...check_stub, remuneration_date: baseDate.clone().add(check_stub.remuneration_date, 'days').format("YYYY-MM-DD")}})}
    }


    const request = axios.put(`${ROOT_URL}/subscribers/incomes`, data, config);

    return {
        type: SAVE_INCOMES,
        payload: request
    };
}

export function saveFiles(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'document_number_front': values.document_number_front,
        'document_number_back': values.document_number_back,
        'tax': values.tax,
        'cbu_document': values.cbu_document,
        'last_pay_check': values.last_pay_check,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/upload`, data, config);
    return {
        type: SAVE_FILES,
        payload: request
    };
}



/** WEBPACK FOOTER **
 ** ./src/actions/users.js
 **/